const FOUR_HOURS_IN_MS = 4 * 60 * 60 * 1000;

export function canEditAppointmentByTime(start?: string): boolean {
  const startTime = new Date(start ?? '').getTime();

  if (Number.isNaN(startTime)) {
    return true;
  }

  return startTime - FOUR_HOURS_IN_MS > Date.now();
}
